import { render, staticRenderFns } from "./BroadcastsIndex.vue?vue&type=template&id=25fef6ec&scoped=true&"
import script from "./BroadcastsIndex.vue?vue&type=script&lang=ts&"
export * from "./BroadcastsIndex.vue?vue&type=script&lang=ts&"
import style0 from "./BroadcastsIndex.vue?vue&type=style&index=0&id=25fef6ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fef6ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VImg,VRow,VSpacer})
